export const MINIFAQ_SOURCES = {
  dashboard: 'Dashboard',
  investing: 'Investing',
  addCash: 'Add_cash',
  withdraw: 'Withdraw',
  loans: 'Loans',
  founders: 'Founders',
  investors: 'Investors',
  activity: 'Activity',
  profile: 'Profile',
  signUp: 'SignUp',
  affiliate: 'affiliate',
  bankDetails: 'Investor_bank_accounts',
  loyalty: 'loyalty',
  investmentStreak: 'Investment_streak',
};
